import React, { useState, useEffect } from 'react';
import { Box, Typography, Stack } from '@mui/material';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import hcinfoLogo from '../../../assets/images/hcinfo.png';
import { getNumberComma } from '../../../utils/numberUtils';
import moment from 'moment';

const EstimatePreview = ({ previewRef, chance, estimate, productCosts }) => {
  const [qteTax, setQteTax] = useState(0);
  const [qteTotal, setQteTotal] = useState(0);

  useEffect(() => {
    if (estimate?.qtePrice && estimate?.qtePrice > 0) {
      let total = 0;
      let tax = 0;
      tax = parseInt(estimate?.qtePrice) * 0.1;

      total = parseInt(estimate?.qtePrice) + parseInt(tax);
      setQteTotal(total);
      setQteTax(tax);
    }
  }, [estimate?.qtePrice]);

  return (
    <Box
      ref={previewRef}
      sx={{
        display: 'flex',
        flexDirection: 'column',
        border: 1,
        borderColor: (theme) => theme.palette.divider,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          py: 1,
          backgroundColor: '#999',
          color: '#fff',
        }}
      >
        <Typography variant="h5" component="div">
          견적서
        </Typography>
        <Typography variant="subtitle1" component="div">
          ( Security Solution Quotation )
        </Typography>
      </Box>
      <Stack
        direction="row"
        spacing={2}
        justifyContent="space-between"
        alignItems="flex-start"
        sx={{ my: 1, px: 1 }}
      >
        <Box sx={{ display: 'flex', flex: 1, flexDirection: 'column' }}>
          <Box
            id="custInfo"
            sx={{
              my: 1,
              border: (theme) => `1px solid ${theme.palette.divider}`,
              px: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Typography
                variant="subtitle2"
                component="div"
                sx={{ mx: 1, width: '150px' }}
              >
                수신(TO)
              </Typography>
              <Typography variant="body2" component="div">
                {chance?.vendorCmpNm}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Typography
                variant="subtitle2"
                component="div"
                sx={{ mx: 1, width: '150px' }}
              >
                고객
              </Typography>
              <Typography variant="body2" component="div">
                {estimate?.qteUsrNm}님 귀하
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Typography
                variant="subtitle2"
                component="div"
                sx={{ mx: 1, width: '150px' }}
              >
                연락처
              </Typography>
              <Typography variant="body2" component="div">
                {estimate?.qteUsrTel} / {estimate?.qteUsrEml}
              </Typography>
            </Box>
            <Box sx={{ my: 1 }}>
              <Typography variant="body2" component="div">
                다음과 같이 견적서를 드립니다.
              </Typography>
              <Typography variant="caption" component="div">
                We Have the Pleasure to Offer You the undermentioned goods
              </Typography>
            </Box>
          </Box>
          <Box
            id="estPriceInfo"
            sx={{
              border: (theme) => `1px solid ${theme.palette.divider}`,
              my: 1,
              px: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '150px',
                }}
              >
                <Typography variant="subtitle2" component="div">
                  견적일자
                </Typography>
                <Typography variant="caption" component="div">
                  (Estimate Date)
                </Typography>
              </Box>
              <Typography variant="body2" component="div">
                {estimate?.qteRegDt
                  ? moment(estimate?.qteRegDt).format('yyyy-MM-DD')
                  : estimate?.crtDt
                  ? moment(estimate?.crtDt).format('yyyy-MM-DD')
                  : moment(new Date()).format('yyyy-MM-DD')}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '150px',
                }}
              >
                <Typography variant="subtitle2" component="div">
                  견적 금액
                </Typography>
                <Typography variant="caption" component="div">
                  (Grand Total)
                </Typography>
              </Box>
              <Typography variant="body2" component="div" sx={{ mx: 1 }}>
                {estimate?.qtePrice
                  ? `₩ ${qteTotal
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`
                  : `-`}
              </Typography>
              <Typography variant="caption" component="div">
                (VAT Included)
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '150px',
                }}
              >
                <Typography variant="subtitle2" component="div">
                  프로젝트명
                </Typography>
                <Typography variant="caption" component="div">
                  (Project Name)
                </Typography>
              </Box>
              <Typography variant="body2" component="div">
                {chance?.cstNm}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '150px',
                }}
              >
                <Typography variant="subtitle2" component="div">
                  납품 장소
                </Typography>
                <Typography variant="caption" component="div">
                  (Destination)
                </Typography>
              </Box>
              <Typography variant="body2" component="div">
                {estimate?.destPlace}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '150px',
                }}
              >
                <Typography variant="subtitle2" component="div">
                  결제 조건
                </Typography>
                <Typography variant="caption" component="div">
                  (Payment Condition)
                </Typography>
              </Box>
              <Typography variant="body2" component="div">
                {estimate?.payCond}
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '150px',
                }}
              >
                <Typography variant="subtitle2" component="div">
                  견적 유효 기간
                </Typography>
                <Typography variant="caption" component="div">
                  (Validity Term)
                </Typography>
              </Box>
              <Typography variant="body2" component="div">
                {estimate?.qteValidDt}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            my: 1,
            // '& *': {
            //     py: 1
            // },
          }}
        >
          <Box
            id="hcCard"
            sx={{
              my: 1,
              border: (theme) => `1px solid ${theme.palette.divider}`,
            }}
          >
            <Box>
              <img src={hcinfoLogo} width="320" height="60" alt="hcinfo" />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Typography variant="subtitle2" component="div" sx={{ mx: 1 }}>
                사업자번호
              </Typography>
              <Typography variant="body2" component="div">
                215-87-68879
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Typography variant="subtitle2" component="div" sx={{ mx: 1 }}>
                대표이사
              </Typography>
              <Typography variant="body2" component="div">
                김경운
              </Typography>
              <Typography variant="caption" component="div">
                (직인생략)
              </Typography>
            </Box>
          </Box>
          <Box
            id="fromInfo"
            sx={{
              my: 1,
              border: (theme) => `1px solid ${theme.palette.divider}`,
              px: 1,
            }}
          >
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
              }}
            >
              <Typography
                variant="subtitle2"
                component="div"
                sx={{ mx: 1, width: '150px' }}
              >
                발신(FROM)
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Typography
                variant="subtitle2"
                component="div"
                sx={{ mx: 1, width: '150px' }}
              >
                담당자
              </Typography>
              <Typography variant="body2" component="div">
                {chance?.crtNm} {chance?.crtGradeNm}
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Typography
                variant="subtitle2"
                component="div"
                sx={{ mx: 1, width: '150px' }}
              >
                Mobile
              </Typography>
              <Typography variant="body2" component="div">
                {chance?.crtTel}
              </Typography>
            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'row' }}>
              <Typography
                variant="subtitle2"
                component="div"
                sx={{ mx: 1, width: '150px' }}
              >
                Email
              </Typography>
              <Typography variant="body2" component="div">
                {chance?.crtEml}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Stack>
      <Box id="productInfo" sx={{ px: 1 }}>
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            mx: 1,
          }}
        >
          <Typography variant="body2" component="div">
            단위:원
          </Typography>
        </Box>
        <TableContainer component={Box}>
          <Table
            size="small"
            aria-label="products"
            sx={{ borderTop: (theme) => `1px solid ${theme.palette.divider}` }}
          >
            <TableHead>
              <TableRow>
                <TableCell align="center">No</TableCell>
                <TableCell align="left">Part No</TableCell>
                <TableCell align="left">Description</TableCell>
                {chance?.prjTyp === 'M' && (
                  <TableCell align="center">Warranty</TableCell>
                )}
                <TableCell align="right">Q'ty</TableCell>
                <TableCell align="right">Unit Price</TableCell>
                <TableCell align="center">Final Amount</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {productCosts?.length &&
                productCosts.map((product, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="center" sx={{ width: '60px' }}>
                      {index + 1}
                    </TableCell>
                    <TableCell>{product?.productNm}</TableCell>
                    <TableCell>
                      <Typography
                        sx={{ whiteSpace: 'pre-line' }}
                        variant="body2"
                        component="div"
                      >
                        {product?.productDesc}
                      </Typography>
                    </TableCell>
                    {chance?.prjTyp === 'M' && (
                      <TableCell align="center">{product?.mntDt} (M)</TableCell>
                    )}
                    <TableCell align="right" sx={{ width: '80px' }}>
                      {getNumberComma(product?.expCnt)}
                    </TableCell>
                    <TableCell align="right" sx={{ width: '150px' }}>
                      {getNumberComma(product?.unitVal)}
                    </TableCell>
                    <TableCell align="right" sx={{ width: '180px' }}>
                      {getNumberComma(product?.saleVal)}
                    </TableCell>
                  </TableRow>
                ))}
              <TableRow>
                <TableCell
                  rowSpan={3}
                  colSpan={chance?.prjTyp === 'M' ? '5' : '4'}
                />
                <TableCell align="right" sx={{ width: '150px' }}>
                  합계 금액
                </TableCell>
                <TableCell align="right" sx={{ width: '180px' }}>
                  {getNumberComma(estimate?.qtePrice)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="right" sx={{ width: '150px' }}>
                  부가세
                </TableCell>
                <TableCell align="right" sx={{ width: '180px' }}>
                  {getNumberComma(qteTax)}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell align="right" sx={{ width: '150px' }}>
                  총 합계 금액
                </TableCell>
                <TableCell align="right" sx={{ width: '180px' }}>
                  {getNumberComma(qteTotal)}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
      <Box
        id="otherInfo"
        sx={{
          my: 1,
          px: 1,
          border: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box>
          <Typography variant="subtitle2" component="div">
            견적 기타사항
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" component="div">
            {estimate?.qteDesc1}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" component="div">
            {estimate?.qteDesc2}
          </Typography>
        </Box>
        <Box>
          <Typography variant="body2" component="div">
            {estimate?.qteDesc3}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default EstimatePreview;
